import 'slick-carousel'
const CLASS_NAME_LINK_SLIDER = 'js-linkSlider'
import { BREAKPOINT_WIDTH } from '~/js/constants/breakpoints'

document.addEventListener('DOMContentLoaded', () => {
  const elementsLinkSlider = document.getElementsByClassName(
    CLASS_NAME_LINK_SLIDER
  )
  Array.from(elementsLinkSlider).forEach((element) => {
    const elementPrev = element.parentElement.getElementsByClassName(
      `${CLASS_NAME_LINK_SLIDER}-prev`
    )[0]
    const elementNext = element.parentElement.getElementsByClassName(
      `${CLASS_NAME_LINK_SLIDER}-next`
    )[0]
    $(element).slick({
      autoplay: element.dataset.autoplay === 'true',
      centerMode: true,
      slidesToShow: 1,
      centerPadding: 0,
      prevArrow: $(elementPrev),
      nextArrow: $(elementNext),
      dots: element.dataset.showDotsDesktop === 'true',
      responsive: [
        {
          breakpoint: BREAKPOINT_WIDTH,
          settings: {
            dots: element.dataset.showDotsMobile === 'true',
          },
        },
      ],
    })

    // スライダーが初期化されたので、ローディングクラスを削除してください。
    element
      .querySelectorAll('.is-loading')
      .forEach((el) => el.classList.remove('is-loading'))
  })
})
